<template>
  <div class="task-card" :style="`border-left: ${color} solid 3px; cursor: pointer;`" @click="onOpen" v-touch:tap="onOpen">
    <div class="task-header">
      <div>
        <p class="task-name pointer">
          <small v-if="personType == 'PF'"><i class="fas fa-user"></i></small>
          <small v-else><i class="fas fa-industry"></i></small>
          <span v-if="task && task.alreadyAssociate" v-b-tooltip.hover title="Associado">
            <i class="fas fa-star text-warning" style="font-size:11px;padding-bottom: 3px"></i>
            <span style="color: #2e6e60;">{{ this.task && this.task.pessoa && this.task.pessoa.nome ?
              this.task.pessoa.nome
              : 'N/D' }}</span>
          </span>
          <span v-else>{{ this.task && this.task.pessoa && this.task.pessoa.nome ? this.task.pessoa.nome : 'N/D' }}</span>
        </p>
      </div>
      <div class="d-flex">
        <b-avatar v-for="responsavel in initials" :key="responsavel.nomeCompleto" variant="info" class="task-image ml-1"
        size="2rem" :text="responsavel.initials" v-b-tooltip.hover :title="responsavel.nomeCompleto"></b-avatar>
      </div>
    </div>
    <div class="task-details" v-if="false">
      <span class="task-value"><small>Valor total:</small><br><strong class="f-12px">R$ 0,00</strong></span>
    </div>
    <div>
      <b-badge v-b-tooltip.hover title="Dias sem contato" :variant="badgeColor">{{ countHoursLastFollowup }}
        Horas</b-badge>
      <span class="pl-2" v-b-tooltip.hover title="Contatos realizados"><i class="fas fa-headset"></i>
        {{ task.cardDetails.countContatos }}</span>
      <span class="pl-2" v-b-tooltip.hover title="E-mail enviado"><i class="fas fa-envelope-open-text"></i>
        {{ task.cardDetails.countEmails }}</span>
      <span class="pl-2" v-b-tooltip.hover title="Quantidade de reativações"><i class="fas fa-recycle"></i>
        {{ task.countReativado }}</span>

      <span v-if="percent < 25" class="pl-2 text-danger" v-b-tooltip.hover title="Percentual de fechamento"><i
          class="fas fa-thermometer-empty"></i> {{ percent }}%</span>
      <span v-else-if="percent >= 25 && percent < 50" class="pl-2 text-danger" v-b-tooltip.hover
        title="Percentual de fechamento"><i class="fas fa-thermometer-quarter"></i> {{ percent }}%</span>
      <span v-else-if="percent >= 50 && percent < 75" class="pl-2 text-warning" v-b-tooltip.hover
        title="Percentual de fechamento"><i class="fas fa-thermometer-half"></i> {{ percent }}%</span>
      <span v-else-if="percent >= 75" class="pl-2 text-third" v-b-tooltip.hover title="Percentual de fechamento"><i
          class="fas fa-thermometer-three-quarters"></i> {{ percent }}%</span>

      <span v-if="!nextAgendamento">&nbsp;|&nbsp; <i class="far fa-calendar-alt" v-b-tooltip.hover
          title="Sem agendamentos"></i></span>

      <span v-if="hasObservation">&nbsp;|&nbsp; <i class="far fa-comments" v-b-tooltip.hover
          :title="'Possui observações'"></i></span>
    </div>
    <div v-if="nextAgendamento && !isNextAgendamentoToday  && !agendamentoVencido" class="proximo-agendamento">
      Próximo agendamento:<br>
      <span style="color: #1e6907; font-weight: 600;">
        <i title="Próximo agendamento" class="far fa-calendar-alt" style=""></i> {{ nextAgendamento }}
      </span>
    </div>
    <div v-if="nextAgendamento && isNextAgendamentoToday && !agendamentoVencido" class="proximo-agendamento-today">
      Próximo agendamento:<br>
      <span>
        <i title="Próximo agendamento" class="far fa-calendar-alt" style=""></i> {{ nextAgendamento }}
      </span>
    </div>
    <div v-if="agendamentoVencido" class="proximo-agendamento-vencido">
      Agendamento Vencido:<br>
      <span>
        <i title="Próximo agendamento" class="far fa-calendar-alt" style=""></i> {{ nextAgendamento }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TaskCard',
  data () {
    return {
      isDataAgendamentoToday: false
    }
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'green'
    },
    boardColumnId: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    boardPosition: {
      type: Number,
      required: true,
      default: 0
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    percentage: {
      type: Number,
      required: false,
      default: 0
    },
    hoursUntilAlert: {
      type: Number,
      required: false,
      default: 365
    },
    hasObservation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    initials () {
      let initials = []

      if (this.task && this.task.responsaveis) {
        this.task.responsaveis.forEach((responsavel) => {
          if (responsavel.usuario && responsavel.usuario.nomePessoa) {
            const names = responsavel.usuario.nomePessoa.split(' ')

            if (names.length > 1) {
              initials.push({
                initials: names[0][0] + names[names.length - 1][0],
                nomeCompleto: responsavel.usuario.nomePessoa
              })
            } else if (names.length > 0) {
              initials.push({
                initials: names[0][0],
                nomeCompleto: responsavel.usuario.nomePessoa
              })
            }
          }
        })
      }

      return initials
    },
    personType: function () {
      let result = 'PF'
      if (this.task && this.task.pessoa && this.task.pessoa.tipoPessoa) {
        return this.task.pessoa.tipoPessoa
      } else {
        result = 'PF'
        if (this.task && this.task.pessoa && this.task.pessoa.document) {
          let doc = this.task.pessoa.document.replace('.', '')
          doc = doc.replace('.', '')
          doc = doc.replace('-', '')
          doc = doc.replace('/', '')

          if (doc.length > 11) {
            result = 'PJ'
          }
        }
      }
      return result
    },
    percent: function () {
      let result = 0
      if (this.percentage && parseInt(this.percentage) > 0) {
        result = this.percentage
      }
      return result
    },
    countHoursLastFollowup () {
      if (this.task && this.task.cardDetails && this.task.cardDetails.ultimoFollowup) {
        let diff = (new Date(this.task.cardDetails.ultimoFollowup).getTime() - new Date().getTime()) / 1000
        diff /= (60 * 60)
        return Math.abs(Math.round(diff))
      }
      return 0
    },
    badgeColor () {
      if (this.hoursUntilAlert && this.countHoursLastFollowup >= this.hoursUntilAlert) {
        return 'danger'
      }
      return 'success'
    },
    nextAgendamento () {
      return this.isNextAgendamento()
    },
    agendamentoVencido () {
      let agendamento = this.isNextAgendamento()
      let dataAtual = this.moment().format('DD/MM/YYYY HH:MM')
      return this.isAgendamentoVencido(agendamento, dataAtual)
    },
    isNextAgendamentoToday () {
      let agendamento = this.isNextAgendamento()
      let dataAtual = this.moment().format('DD/MM/YYYY')
      let ag = this.moment(agendamento, 'DD/MM/YYYY')
      let hoje = this.moment(dataAtual, 'DD/MM/YYYY')
      let dataDiff = hoje.diff(ag, 'days')

      if (dataDiff === 0 || agendamento === null || agendamento === undefined) {
        return true
      }

      return false
    }
  },
  methods: {
    onOpen () {
      this.$emit('Open', { cardID: this.task.id })
    },
    isNextAgendamento () {
      if (this.task && this.task.cardDetails && this.task.cardDetails.agendamento) {
        let agendamento = this.task.cardDetails.agendamento

        if (agendamento) {
          agendamento = this.moment.utc(agendamento).format('DD/MM/YYYY HH:mm')
        }

        return agendamento
      }
      return false
    },
    isAgendamentoVencido (agendamento, dataAtual) {
      let ag = this.moment(agendamento, 'DD/MM/YYYY hh:mm')
      let hoje = this.moment(dataAtual, 'DD/MM/YYYY hh:mm')
      return hoje.diff(ag, 'minutes') > 0
    }
  }
}
</script>

<style scoped>
.proximo-agendamento {
  margin-top: 6px;
  background-color: #e9e9e9;
  border-radius: 4px;
  padding: 10px;
  border: solid 1px #dee2e6;
}

.proximo-agendamento-today {
  margin-top: 6px;
  background-color: #75c044;
  border-radius: 4px;
  padding: 10px;
  color: white;
}

.proximo-agendamento-vencido {
  margin-top: 6px;
  background-color: #da3131;
  border-radius: 4px;
  padding: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/components/TaskCard.vue